import { Trans } from "@lingui/macro";
import { IUiBoxProps, UiBox, UiTypography } from "@smp/ui";
import { IconHourglassHigh } from "@tabler/icons-react";
import { clsx } from "clsx";
import { FC } from "react";

import classes from "./disclaimer.module.css";

export const Disclaimer: FC<IUiBoxProps> = (props) => (
  <UiBox {...props} className={clsx(classes.box, props.className)}>
    <IconHourglassHigh />

    <div>
      <UiTypography variant="body2">
        <Trans>Generation of posts can take from 1 to 3 minutes</Trans>
      </UiTypography>
      <UiTypography variant="body2">
        <Trans>Do not close the window or reload the page.</Trans>
      </UiTypography>
    </div>
  </UiBox>
);
